import { RBCardView } from "../../components/RBCardView";
import React, { useState, useEffect ,useContext} from "react";
import { StarRatings, EditableStarRatings } from "../../components/StarRatings";
import { OpenInNewSharp } from "@material-ui/icons";
import { Spacing, Colors, Font, FontFamily, FontWeight } from "../../theme/Theme";
import { Typography } from "@material-ui/core";
import { EmptyString, RoutePathConstant } from "../../util/Common";
import { RBSwitch } from "../../components/RBSwitch";
import { RBButton } from "../../components/RBButton";
import { ShiftService } from "../../api/ShiftService";
import { useRouteMatch, useHistory } from "react-router-dom";
import { ErrorMessageProps } from "../../interfacesProps/ErrorMessageProps";
import { RBContext } from "../../components/RBContext";
import { RBAlert } from "../../components/RBAlert";
import { RBModal } from "../../components/RBModal";
import { RBEmptyBlock } from "../../components/RBEmptyBlock";
import { RBTextField } from "../../components/RBTextField";
import { AuthService } from "../../api/AuthService";
import { PharmacyService } from "../../api/PharmacyService";
import { LoadingIndicator } from "../../components/LoadingIndicator";
import { AccountInfoContext } from "../../components/AccountInfoContext";

const QUESTIONS = [
  "Did the candidate work well with other staff members?",
  "Did the candidate have good customer service skills?",
  "How was the candidate in completing their tasks?",
  "Would you considering hiring this candidate again?",
];

export const ShiftSurveyPharmaOwner: React.FC = () => {
  const { industryMode,primaryColor,secondaryColor } = useContext(RBContext);
  const [isPunctual, setIsPunctual] = useState(true);
  const [answers, setAnswers] = useState([5, 5, 5, 5]);
  const [starTexts, setStarTexts] = useState([
    EmptyString,
    EmptyString,
    EmptyString,
    EmptyString,
    EmptyString,
  ]);
  const [isFormValid, setIsFormValid] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const history = useHistory();
  const match = useRouteMatch<{ shiftId: string }>();
  const [submitErrorMessage, setSubmitErrorMessage] = useState<
    ErrorMessageProps
  >();
  const [successAlertShowing, setSuccessAlertShowing] = useState(false);

  const [isFetchingShift, setIsFetchingShift] = useState(true);
  const [activeShift, setActiveShift] = useState<any>(null);
  const [isBlockedByOther, setIsBlockedByOther] = useState(false);

  const [blockUserDialogVisible, setBlockUserDialogVisible] = useState(false);
  const [blockUserComment, setBlockUserComment] = useState('');
  const [feedbackLoading, setFeedbackLoading] = useState(false);

  const [blockSuccessAlertShowing, setBlockSuccessAlertShowing] = useState(false);
  const [blockFailureAlertShowing, setBlockFailureAlertShowing] = useState(false);
  const [blockAlertMessage, setBlockAlertMessage] = useState('');
  
  const { accountInformation } = useContext(AccountInfoContext);

  useEffect(() => {
    let isMounted = true;
    (async () => {
      setIsFetchingShift(true);
      try {
        const shiftDetail = (await ShiftService.getShiftDetailByShiftId(match.params.shiftId)) as any;
        if (!isMounted) {
          return;
        }
        setActiveShift(shiftDetail ?? null);

        try {
          const accountInfo = accountInformation;
          const blocks =
            accountInfo?.blockedList ??
            accountInfo?.owner?.blockedList ??
            accountInfo?.pharmacist?.blockedList ??
            [];

          const currentUserIdRaw = localStorage.getItem('userId');
          const currentUserId = currentUserIdRaw != null ? String(currentUserIdRaw) : null;

          const ownerIdRaw = shiftDetail?.creator?.id ?? null;
          const workerIdRaw = shiftDetail?.pharmacist?.id ?? null;
          const counterpartyIdRaw = workerIdRaw;
          const counterpartyId = counterpartyIdRaw != null ? String(counterpartyIdRaw) : null;

          const blocked =
            Array.isArray(blocks) && currentUserId && counterpartyId
              ? blocks.some((block: any) => {
                  const blockedUserId = block?.userId != null ? String(block.userId) : null;
                  const blockerId =
                    block?.blockUserId != null
                      ? String(block.blockUserId)
                      : block?.blockedByUser?.id != null
                        ? String(block.blockedByUser.id)
                        : null;
                  return blockedUserId === currentUserId && blockerId === counterpartyId;
                })
              : false;

          setIsBlockedByOther(Boolean(blocked));
        } catch (error) {
          setIsBlockedByOther(false);
        }
      } catch (error) {
        if (!isMounted) {
          return;
        }
        setActiveShift(null);
        setIsBlockedByOther(false);
      } finally {
        if (isMounted) {
          setIsFetchingShift(false);
        }
      }
    })();

    return () => {
      isMounted = false;
    };
  }, [match.params.shiftId]);
  useEffect(() => {
    let tempStarTexts: string[] = [];
    starTexts.forEach((starText) => tempStarTexts.push(starText));

    console.log("useEffect tempStarTexts ", tempStarTexts);
    for (let index = 0; index < answers.length; index++) {
      switch (answers[index]) {
        case 0:
          tempStarTexts[index] = EmptyString;
          break;
        case 1:
          tempStarTexts[index] = "Poor";
          break;
        case 2:
          tempStarTexts[index] = "Below Average";
          break;
        case 3:
          tempStarTexts[index] = "Average";
          break;
        case 4:
          tempStarTexts[index] = "Good";
          break;
        case 5:
          tempStarTexts[index] = "Excellent";
          break;
      }
    }
    for (let index = 0; index < answers.length; index++) {
      if (answers[index] === 0) {
        // make the submit button invalid
        setIsFormValid(false);
        break;
      }
      setIsFormValid(true);
    }

    setStarTexts(tempStarTexts);
  }, [JSON.stringify(answers)]);

  const submitShiftSurvey = async () => {
    try {
      setIsSubmitting(true);

      const payload = {
        q1: isPunctual,
        q2: answers[0],
        q3: answers[1],
        q4: answers[2],
        q5: answers[3],
      };
      await ShiftService.updateShiftRating(match.params.shiftId, payload);
      setSuccessAlertShowing(true);
    } catch (e) {
      const err = e as any;
      setSubmitErrorMessage(
        err?.response ? err.response.data.message : err?.message,
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  const onCloseBlockDialog = () => {
    if (feedbackLoading) {
      return;
    }
    setBlockUserDialogVisible(false);
    setBlockUserComment('');
  };

  const onBlockUser = async () => {
    if (!activeShift?.id || feedbackLoading || isFetchingShift || isBlockedByOther) {
      return;
    }

    setFeedbackLoading(true);
    try {
      await AuthService.blockUser({
        comment: blockUserComment.length > 0 ? blockUserComment : null,
        shiftId: activeShift.id,
      });

      await PharmacyService.updateShiftFeedback({ id: activeShift.id, locationFeedbackGiven: true } as any);

      setBlockUserDialogVisible(false);
      setBlockUserComment('');
      setIsBlockedByOther(true);
      setBlockAlertMessage('The worker has been blocked successfully.');
      setBlockSuccessAlertShowing(true);
    } catch (error) {
      console.log('onBlockUser', error);
      setBlockUserDialogVisible(false);
      setBlockAlertMessage('Unable to block at this time. Please try again later.');
      setBlockFailureAlertShowing(true);
    } finally {
      setFeedbackLoading(false);
    }
  };

  const goBackAfterSubmit = () => {
    if (history.length > 1) {
      history.goBack();
      return;
    }
    history.replace(RoutePathConstant.Payroll);
  };

  if (isFetchingShift) {
    return <LoadingIndicator />;
  }

  return (
    <>
      <RBAlert
        show={successAlertShowing}
        alertTitle="Rating Submitted"
        alertMessage="Your rating has been submitted successfully."
        buttons={[
          <RBButton
            key="ok"
            text="Thank You!"
            onClick={() => {
              setSuccessAlertShowing(false);
              goBackAfterSubmit();
            }}
            buttonBackgroundColor={primaryColor}
          />,
        ]}
      />

      <RBAlert
        show={blockSuccessAlertShowing}
        alertTitle="Blocked Successfully"
        alertMessage={blockAlertMessage}
        buttons={[
          <RBButton
            key="ok"
            text="OK"
            onClick={() => setBlockSuccessAlertShowing(false)}
            buttonBackgroundColor={primaryColor}
          />,
        ]}
      />

      <RBAlert
        show={blockFailureAlertShowing}
        alertTitle="Block Failed"
        alertMessage={blockAlertMessage}
        buttons={[
          <RBButton
            key="ok"
            text="OK"
            onClick={() => setBlockFailureAlertShowing(false)}
            buttonBackgroundColor={primaryColor}
          />,
        ]}
      />

      <RBModal
        open={blockUserDialogVisible}
        onClose={onCloseBlockDialog}
        modalTitle={"Block"}
        backDropEnabled={!feedbackLoading}
        modalWidth={500}
        header={
          <RBEmptyBlock
            style={{
              width: '100%',
              height: Spacing.large,
              backgroundColor: Colors.defaultGrey,
              flexShrink: 0,
            }}
          />
        }
      >
        <div
          style={{
            backgroundColor: Colors.defaultGrey,
            display: 'flex',
            flex: 1,
          }}
        >
          <RBCardView
            style={{
              flex: 1,
              margin: Spacing.large,
              padding: Spacing.large,
            }}
          >
            <Typography
              style={{
                // fontFamily: FontFamily.family,
                fontSize: Font.default,
                fontWeight: FontWeight.bold as React.CSSProperties['fontWeight'],
              }}
            >
              Would you like to block this worker?
            </Typography>

            <div style={{ marginTop: Spacing.large }}>
              <RBTextField
                placeholder="*Please leave a comment if you decide to block."
                value={blockUserComment}
                onChange={(e) => setBlockUserComment((e.target as HTMLInputElement).value)}
                multiline
                rows={4}
              />
            </div>

            <div style={{ marginTop: Spacing.large, color: Colors.red }}>
              <Typography
                style={{
                  // fontFamily: FontFamily.family,
                  fontSize: Font.small,
                }}
              >
                *Blocking will prevent this worker from being matched with your future shifts.
              </Typography>
            </div>

            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                marginTop: Spacing.large,
              }}
            >
              <RBButton
                buttonBackgroundColor={primaryColor}
                isLoading={feedbackLoading}
                disabled={blockUserComment.length === 0 || feedbackLoading}
                text="Block"
                onClick={onBlockUser}
                style={{ flex: 1, padding: Spacing.medium, marginRight: Spacing.small }}
              />
              <RBButton
                buttonBackgroundColor={primaryColor}
                disabled={feedbackLoading}
                text="Cancel"
                onClick={onCloseBlockDialog}
                style={{ flex: 1, padding: Spacing.medium, marginLeft: Spacing.small }}
              />
            </div>
          </RBCardView>
        </div>
      </RBModal>

      <RBCardView style={{ margin: Spacing.large, padding: Spacing.large }}>
        {submitErrorMessage && (
          <div style={{ color: "red", marginBottom: Spacing.large }}>
            {JSON.stringify(submitErrorMessage, null, 2)}
          </div>
        )}
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: Spacing.large,
          }}
        >
          <Typography
            variant={"h6"}
            style={{
              color: Colors.themeDarkBlue,
              marginRight: Spacing.large,
            }}
          >
            Was the candidate punctual?
          </Typography>
          <RBSwitch
            checked={isPunctual}
            onChange={(event, checked) => setIsPunctual(checked)}
            label={isPunctual ? "Yes" : "No"}
            formControlStyle={{ width: 50 }}
          />
        </div>
        <div
          style={{
            height: 1,
            backgroundColor: Colors.defaultGrey,
            marginBottom: Spacing.large,
          }}
        />

        {QUESTIONS.map((question: any, index: number) => {
          return (
            <div key={index}>
              <div style={{ textAlign: "center", marginBottom: Spacing.large }}>
                <Typography
                  variant={"h6"}
                  style={{
                    color: Colors.themeDarkBlue,
                    marginBottom: Spacing.small,
                  }}
                >
                  {question}
                </Typography>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Typography style={{ color: '#ffb400' }}>
                    {starTexts[index]}
                  </Typography>
                  <EditableStarRatings
                    name={index.toString()}
                    defaultRating={answers[index]}
                    onValueChange={(value: number) => {
                      let newAnswer = [];
                      answers.forEach((answer) => newAnswer.push(answer));
                      newAnswer[index] = value;
                      setAnswers(newAnswer);
                    }}
                  />
                </div>
              </div>
              <div
                style={{
                  height: 1,
                  backgroundColor: Colors.defaultGrey,
                  marginBottom: Spacing.large,
                }}
              />
            </div>
          );
        })}
      </RBCardView>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          margin: Spacing.large,
          marginTop: 0,
        }}
      >
        <RBButton
          onClick={() => setBlockUserDialogVisible(true)}
          text={isBlockedByOther ? 'Already Blocked' : 'Block User'}
          disabled={isBlockedByOther || feedbackLoading}
          style={{ flex: 1, padding: Spacing.large, marginRight: Spacing.small }}
          buttonBackgroundColor={primaryColor}
        />
        <RBButton
          isLoading={isSubmitting}
          onClick={submitShiftSurvey}
          disabled={!isFormValid}
          text="Submit"
          style={{ flex: 1, padding: Spacing.large, marginLeft: Spacing.small }}
          buttonBackgroundColor={primaryColor}
        />
      </div>
    </>
  );
};

export default ShiftSurveyPharmaOwner;
